import React, { FC } from 'react';
import SettingsOutlinedIcon from '@mui/icons-material/SettingsOutlined';
import {
    AccountIcon,
    CohortIcon,
    HelpIcon,
    MerchantsIcon,
    ProductsIcon,
    ReportsIcon,
    ScannerProfileIcon,
    ScannersIcon,
    ScansIcon,
} from '../IconSelectorComponent/IconSelectorComponent';

interface NavigationIconSelectorComponentProps {
    icon: string;
}

const NavigationIconSelectorComponent: FC<NavigationIconSelectorComponentProps> = ({ icon }) => {
    switch (icon) {
        case 'scans':
            return <ScansIcon />;
        case 'scanners':
            return <ScannersIcon />;
        case 'profile':
            return <ScannerProfileIcon />;
        case 'reports':
            return <ReportsIcon />;
        case 'products':
            return <ProductsIcon />;
        case 'help':
            return <HelpIcon />;
        case 'merchants':
            return <MerchantsIcon />;
        case 'account':
            return <AccountIcon />;
        case 'cohorts':
            return <CohortIcon />;
        case 'settings':
            return <SettingsOutlinedIcon />;
        default:
            return null;
    }
};

export default NavigationIconSelectorComponent;
